import { memo } from 'react';
import PortalIdParser from 'PortalIdParser';
import I18n from 'I18n';
// @ts-expect-error no declarations found for module
import KnowledgeBaseButton from 'ui-addon-i18n/components/KnowledgeBaseButton';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import UIList from 'UIComponents/list/UIList';
import { trackInsightsInteraction } from 'messaging-publishing-lib/utils/tracking';
import UILink from 'UIComponents/link/UILink';
import { jsx as _jsx } from "react/jsx-runtime";
function KnowledgeBaseButtonWithInsightsTracking(props) {
  return /*#__PURE__*/_jsx(KnowledgeBaseButton, Object.assign({}, props, {
    onClick: () => {
      trackInsightsInteraction({
        action: 'click-knowledge-base-button'
      });
    }
  }));
}
function Recommendation({
  recommendation
}) {
  switch (recommendation.insightRecommendationType) {
    case 'READ_KB_ARTICLE':
      {
        const url = recommendation.metadata.action.kbArticleLink;
        return /*#__PURE__*/_jsx(FormattedJSXMessage, {
          message: "messaging-insights.insights.recommendations.READ_KB_ARTICLE_jsx",
          elements: {
            KnowledgeBaseButton: () => /*#__PURE__*/_jsx(KnowledgeBaseButtonWithInsightsTracking, {
              url: url
            })
          }
        });
      }
    case 'REVIEW_SENDING_LIST':
      {
        return /*#__PURE__*/_jsx(FormattedJSXMessage, {
          message: "messaging-insights.insights.recommendations.REVIEW_SENDING_LIST_jsx",
          elements: {
            KnowledgeBaseButton: ({
              children
            }) => /*#__PURE__*/_jsx(KnowledgeBaseButtonWithInsightsTracking, {
              url: "https://knowledge.hubspot.com/marketing-email/how-to-clean-up-your-contact-lists-to-improve-deliverability",
              children: children
            })
          }
        });
      }
    case 'SHORTEN_SUBJECT_LINE':
      {
        return /*#__PURE__*/_jsx(FormattedJSXMessage, {
          message: "messaging-insights.insights.recommendations.SHORTEN_SUBJECT_LINE_jsx",
          elements: {
            KnowledgeBaseButton: () => /*#__PURE__*/_jsx(KnowledgeBaseButtonWithInsightsTracking, {
              url: "https://blog.hubspot.com/marketing/improve-your-email-subject-line"
            })
          }
        });
      }
    case 'USE_FEWER_EMOJIS_IN_SUBJECT_LINE':
      {
        return /*#__PURE__*/_jsx(FormattedJSXMessage, {
          message: "messaging-insights.insights.recommendations.USE_FEWER_EMOJIS_IN_SUBJECT_LINE_jsx",
          elements: {
            KnowledgeBaseButton: () => /*#__PURE__*/_jsx(KnowledgeBaseButtonWithInsightsTracking, {
              url: "https://blog.hubspot.com/marketing/improve-your-email-subject-line"
            })
          }
        });
      }
    case 'USE_PREVIEW_TEXT':
      {
        return /*#__PURE__*/_jsx(FormattedJSXMessage, {
          message: "messaging-insights.insights.recommendations.USE_PREVIEW_TEXT_jsx",
          elements: {
            KnowledgeBaseButton: ({
              children
            }) => /*#__PURE__*/_jsx(KnowledgeBaseButtonWithInsightsTracking, {
              url: "https://knowledge.hubspot.com/marketing-email/generate-preview-text-for-marketing-emails-using-hubspot-ai",
              children: children
            })
          }
        });
      }
    case 'REDUCE_EMAIL_SIZE':
      {
        return /*#__PURE__*/_jsx(FormattedJSXMessage, {
          message: "messaging-insights.insights.recommendations.REDUCE_EMAIL_SIZE_jsx",
          elements: {
            KnowledgeBaseButton: ({
              children
            }) => /*#__PURE__*/_jsx(KnowledgeBaseButtonWithInsightsTracking, {
              url: "https://knowledge.hubspot.com/marketing-email/how-can-i-optimize-my-email-for-mobile-devices#fix-gmail-clipping-issues",
              children: children
            })
          }
        });
      }
    case 'USE_SENDER_PERSONALISATION':
      {
        return /*#__PURE__*/_jsx(FormattedMessage, {
          message: "messaging-insights.insights.recommendations.USE_SENDER_PERSONALISATION"
        });
      }
    case 'USE_CONSISTENT_SENDING_PATTERNS':
      {
        return /*#__PURE__*/_jsx(FormattedMessage, {
          message: "messaging-insights.insights.recommendations.USE_CONSISTENT_SENDING_PATTERNS"
        });
      }
    case 'ENABLE_GRAYMAIL':
      {
        const href = `/settings/${PortalIdParser.get()}/marketing/email/subscriptions`;
        return [/*#__PURE__*/_jsx(FormattedJSXMessage, {
          message: "messaging-insights.insights.recommendations.ENABLE_GRAYMAIL.portal_jsx",
          elements: {
            EmailSettingsLink: ({
              children
            }) => /*#__PURE__*/_jsx(UILink, {
              external: true,
              href: href,
              children: children
            })
          }
        }, "portal"), /*#__PURE__*/_jsx(FormattedJSXMessage, {
          message: "messaging-insights.insights.recommendations.ENABLE_GRAYMAIL.email_jsx",
          elements: {
            KnowledgeBaseButton: ({
              children
            }) => /*#__PURE__*/_jsx(KnowledgeBaseButtonWithInsightsTracking, {
              url: "https://knowledge.hubspot.com/marketing-email/what-is-graymail-and-how-can-i-avoid-sending-my-email-to-unengaged-contacts",
              children: children
            })
          }
        }, "email")];
      }
    case 'IMPROVE_CTA_TEXT':
      {
        var _recommendation$metad, _action$topEmailCtas;
        const action = (_recommendation$metad = recommendation.metadata) === null || _recommendation$metad === void 0 ? void 0 : _recommendation$metad.action;
        if (action.type === 'IMPROVE_BASED_ON_TOP_EMAILS' && (_action$topEmailCtas = action.topEmailCtas) !== null && _action$topEmailCtas !== void 0 && _action$topEmailCtas.length) {
          return /*#__PURE__*/_jsx(FormattedMessage, {
            message: "messaging-insights.insights.recommendations.IMPROVE_CTA_TEXT.topEmailCtas",
            options: {
              ctas: I18n.formatList(action.topEmailCtas.map(cta => `"${cta}"`))
            }
          });
        }
        return /*#__PURE__*/_jsx(FormattedMessage, {
          message: "messaging-insights.insights.recommendations.IMPROVE_CTA_TEXT.default"
        });
      }
    case 'USE_CONTENT_PERSONALISATION':
      {
        return recommendation.metadata.recommendationIsForContinuousSend ? /*#__PURE__*/_jsx(FormattedMessage, {
          message: "messaging-insights.insights.recommendations.USE_CONTENT_PERSONALISATION.automated"
        }) : /*#__PURE__*/_jsx(FormattedMessage, {
          message: "messaging-insights.insights.recommendations.USE_CONTENT_PERSONALISATION.regular"
        });
      }
    case 'REDUCE_NUMBER_OF_IMAGES_WITHOUT_LINKS':
      {
        return /*#__PURE__*/_jsx(FormattedMessage, {
          message: "messaging-insights.insights.recommendations.REDUCE_NUMBER_OF_IMAGES_WITHOUT_LINKS",
          options: {
            maximumIdealNumberOfImagesWithoutLinks: recommendation.metadata.action.maximumIdealNumberOfImagesWithoutLinks
          }
        });
      }
    case 'REDUCE_NUMBER_OF_IMAGES':
      {
        return recommendation.metadata.recommendationIsForContinuousSend ? /*#__PURE__*/_jsx(FormattedMessage, {
          message: "messaging-insights.insights.recommendations.REDUCE_NUMBER_OF_IMAGES.automated"
        }) : /*#__PURE__*/_jsx(FormattedMessage, {
          message: "messaging-insights.insights.recommendations.REDUCE_NUMBER_OF_IMAGES.regular"
        });
      }
    case 'REDUCE_NUMBER_OF_LINKS':
      {
        return recommendation.metadata.recommendationIsForContinuousSend ? /*#__PURE__*/_jsx(FormattedMessage, {
          message: "messaging-insights.insights.recommendations.REDUCE_NUMBER_OF_LINKS.automated"
        }) : /*#__PURE__*/_jsx(FormattedMessage, {
          message: "messaging-insights.insights.recommendations.REDUCE_NUMBER_OF_LINKS.regular"
        });
      }
    case 'SHORTEN_CTA_TEXT':
      {
        var _recommendation$metad2;
        const action = (_recommendation$metad2 = recommendation.metadata) === null || _recommendation$metad2 === void 0 ? void 0 : _recommendation$metad2.action;
        if (action && action.type === 'SHORTEN_BASED_ON_TOP_EMAILS' && typeof action.topEmailMinimumCtaLength === 'number' && typeof action.topEmailMaximumCtaLength === 'number') {
          return /*#__PURE__*/_jsx(FormattedMessage, {
            message: "messaging-insights.insights.recommendations.SHORTEN_CTA_TEXT.topEmailCtas",
            options: {
              minLength: action.topEmailMinimumCtaLength,
              maxLength: action.topEmailMaximumCtaLength
            }
          });
        }
        return /*#__PURE__*/_jsx(FormattedMessage, {
          message: "messaging-insights.insights.recommendations.SHORTEN_CTA_TEXT.default"
        });
      }
    default:
      {
        return null;
      }
  }
}
function Recommendations({
  recommendations
}) {
  const recommendationListItems = recommendations.flatMap(recommendation => Recommendation({
    recommendation
  }));
  if (recommendationListItems.length === 1) return recommendationListItems;
  return /*#__PURE__*/_jsx(UIList, {
    styled: true,
    children: recommendationListItems
  });
}
export default /*#__PURE__*/memo(Recommendations);